import { useNetwork } from "../../context/NetworkContext";

export default function ApiButton({ children, disabled, style, className, ...props }) {
    const { ready } = useNetwork();
    const isDisabled = disabled || !ready;

    return (
        <button
            {...props}
            className={className}
            disabled={isDisabled}
            title={!ready ? "Sem conexão com o servidor" : props.title}
            style={{
                ...style,
                opacity: isDisabled ? 0.5 : undefined,
                cursor: isDisabled ? "not-allowed" : undefined,
            }}
        >
            {children}
        </button>
    );
}
